import type { GridCell, Level, LevelRecord, Phase } from "./types";
import { LEVELS } from "./levels";

const key = (c: GridCell) => c[0] + "," + c[1];

/** Mutable, session-global game state, kept in one object so feature modules
 *  can share it without a tangle of cross-module setters. */
export const state = {
  /** The current level definition. */
  level(): Level { return LEVELS[this.idx]; },
  phase: "intro" as Phase,
  /** Current level index. */
  idx: 0,
  /** The walls the player has placed on the current level (added, not base). */
  walls: [] as GridCell[],
  /** Whether each labyrinth has been finished at the proven-best (3 stars). */
  completed: LEVELS.map(() => false),
  /** Persisted working walls per level, so navigating back restores work. */
  saved: LEVELS.map(() => [] as GridCell[]),
  /** Best result per level (longest forced path), fed to the reveal. */
  records: LEVELS.map((): LevelRecord => ({ walls: [], length: 0 })),

  /** Is `cell` currently a player-placed wall? */
  hasWall(cell: GridCell): boolean {
    return this.walls.some((w) => key(w) === key(cell));
  },
};
